import { render, staticRenderFns } from "./OrgModerateModeration.vue?vue&type=template&id=2b486375"
import script from "./OrgModerateModeration.vue?vue&type=script&lang=js"
export * from "./OrgModerateModeration.vue?vue&type=script&lang=js"
import style0 from "./OrgModerateModeration.vue?vue&type=style&index=0&id=2b486375&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports